<template>
    <div class="menu">
        <div class="top">
            <h2>编辑菜单</h2>
            <!--<DatePicker type="date" v-model="date1" @on-change="serchDate"></DatePicker>
            <DatePicker type="date" v-model="date2" @on-change="serchDate"></DatePicker>-->
        </div>
        <div class="tottom nui-scroll">
            <table class="tableList" border="">
                <tr>
                    <td>
                        日期
                    </td>
                    <td>
                        餐次
                    </td>
                    <td>
                        菜单
                    </td>
                    <td>
                    	 
                    </td>
                </tr>
            </table>
            <table :class="{isGray : showBtn[index] || showBtn2[index] ||showBtn3[index]}" class="nui-scroll tableList" border="" v-for="(item,index) in dinnerData" :key="index">
                <tr>
                    <td rowspan="3"><span>{{item.dateStr}}</span></td>
                    <td>早餐</td>
                    <td>
                    	<textarea v-show="showBtn[index]" style="background: transparent;resize: none;width: 92%;" :class="{ haveK : showBtn[index]}" v-model="item.breakfast"></textarea>
                    	<!--<input v-show="showBtn[index]" style="background: transparent;" :class="{ haveK : showBtn[index]}" v-model="item.breakfast" type="text">-->
                    	<span v-show="!showBtn[index]">{{item.breakfast}}</span>
                    </td>
                    <td class="buttonIt">
                    	<Button v-show="showBtn[index]" @click="set(showBtn, index, false)" type="primary">确认</Button>
                    	<div v-show="!showBtn[index]" @click="set(showBtn, index, true)"></div>
                    </td>
                </tr>
                <tr>
                    <td>午餐</td>
                    <td>
                    	<textarea v-show="showBtn2[index]" style="background: transparent;resize: none;width: 92%;" :class="{ haveK : showBtn2[index]}" type="text" v-model="item.lunch"></textarea>
                    	<!--<input v-show="showBtn2[index]" style="background: transparent;" :class="{ haveK : showBtn2[index]}" type="text" v-model="item.lunch">-->
                    	<span v-show="!showBtn2[index]">{{item.lunch}}</span>
                    	</td>
                    <td class="buttonIt">
                    	<Button v-show="showBtn2[index]" @click="set(showBtn2, index, false)" type="primary">确认</Button>
                    	<div v-show="!showBtn2[index]" @click="set(showBtn2, index, true)"></div>
                    </td>
                </tr>
                <tr>
                    <td>晚餐</td>
                    <td>
                        <textarea v-show="showBtn3[index]" style="background: transparent;resize: none;width: 92%;" :class="{ haveK : showBtn3[index]}" type="text" v-model="item.dinner"></textarea>
                        <!--<input v-show="showBtn2[index]" style="background: transparent;" :class="{ haveK : showBtn2[index]}" type="text" v-model="item.lunch">-->
                        <span v-show="!showBtn3[index]">{{item.dinner}}</span>
                    </td>
                    <td class="buttonIt">
                        <Button v-show="showBtn3[index]" @click="set(showBtn3, index, false)" type="primary">确认</Button>
                        <div v-show="!showBtn3[index]" @click="set(showBtn3, index, true)"></div>
                    </td>
                </tr>
            </table>
        </div>
        <Row style="text-align: center; ">
            <Button @click="save" class="btton" type="primary">保存</Button>
        </Row>
    </div>
</template>


<script>
    export default {
        data () {
          return{
              date1: new Date(),
              date2: new Date(),
              dataArr: [],
              dinnerData:[],
              showBtn: [false],
              showBtn2: [false],
              showBtn3: [false],
              isDis:true
          }
        },
        components:{

        },
        methods:{
        	timeIsOK(time){
        		if(time >= new Date().format("yyyy-MM-dd")){
        			return true;
        		}else{
        			return false;
        		}
        		
        	},
        	set(a,b,c){
        		this.$set(a,b,c);
        	},
        	getBole(e){
        		console.log(e);
        		return e;
        	},
        	isOk(index){
        		console.log(index);
        	},
        	isOk2(index){
        		this.showBtn2[index] = !this.showBtn2[index];
        	},
            save(){
            	var that = this;
                var params = {
                    data: {
                        "Monday_breakfast" : this.dinnerData[0].breakfast,
						"Monday_lunch" : this.dinnerData[0].lunch,
						"Monday_dinner" : this.dinnerData[0].dinner,
						"Tuesday_breakfast" : this.dinnerData[1].breakfast,
						"Tuesday_lunch" : this.dinnerData[1].lunch,
						"Tuesday_dinner" : this.dinnerData[1].dinner,
						"Wednesday_breakfast" : this.dinnerData[2].breakfast,
						"Wednesday_lunch" : this.dinnerData[2].lunch,
						"Wednesday_dinner" : this.dinnerData[2].dinner,
						"Thursday_breakfast" : this.dinnerData[3].breakfast,
						"Thursday_lunch" : this.dinnerData[3].lunch,
						"Thursday_dinner" : this.dinnerData[3].dinner,
						"Friday_breakfast" : this.dinnerData[4].breakfast,
						"Friday_lunch" : this.dinnerData[4].lunch,
						"Friday_dinner" : this.dinnerData[4].dinner
                    },
                    token: window.localStorage.getItem("token"),
                    url: '/sys/bookmealsetting/savebg',
                    success: (res) => {
                        if(res.data.code == "0000"){
                            that.$Message.success({
                                content: "保存成功"
                            });
                            that.serchDate();
                        }
                    }
                }
                this.ajaxPost(params);
            },
            getDays(strDateStart,strDateEnd){
                var strSeparator = "-"; //日期分隔符
                var oDate1;
                var oDate2;
                var iDays;
                oDate1= strDateStart.split(strSeparator);
                oDate2= strDateEnd.split(strSeparator);
                var strDateS = new Date(oDate1[0], oDate1[1]-1, oDate1[2]);
                var strDateE = new Date(oDate2[0], oDate2[1]-1, oDate2[2]);
                iDays = parseInt(Math.abs(strDateS - strDateE ) / 1000 / 60 / 60 /24)//把相差的毫秒数转换为天数 
                return iDays ;
            },
            serchDate(){
//              if(this.date2<this.date1 || !this.date2 || !this.date1){
//                  this.$Message.error({
//                      content: "其填写正确是时间区间"
//                  });
//              }else if(this.getDays(this.date2.format("yyyy-MM-dd"),this.date1.format("yyyy-MM-dd"))>30){
//              	this.$Message.error({
//                      content: "时间差距不能多于30天"
//                  });
//              }else{
//                  var that = this;
//                  if((parseInt(this.date1.format("dd"))-parseInt(this.date2.format("dd")))<=0){
//                  	var len = (parseInt(this.date2.format("dd"))-parseInt(this.date1.format("dd")))+1;
//                  }else{
//                  	var addIt = new Date(parseInt(this.date1.format("yyyy")), parseInt(this.date2.format("MM"))-1, 0).getDate();
//                  	var len = (parseInt(this.date2.format("dd"))-parseInt(this.date1.format("dd")))+addIt+1;
//                  }
//                  console.log("len",len);
//                  this.dinnerData = [];
//                  for(var i=0;i<len;i++){
//                      var n;
//                      if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 1){
//                          n = "一";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 2){
//                          n = "二";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 3){
//                          n = "三";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 4){
//                          n = "四";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 5){
//                          n = "五";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 6){
//                          n = "六";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 0){
//                          n = "日";
//                      }
//                      // if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 6 || new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 0){
//                          
//                      // }else{
//                          var obj = {
//                              date: new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).format("yyyy-MM-dd"),
//                              dateStr: new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).format("yyyy年MM月dd日") + "     星期"+n,
//                              breakfast: "",
//                              lunch: ""
//                          };
//                          this.dinnerData.push(obj);
//                      // }
//                  }
//                  console.log(that.date1.format("yyyy-MM-dd")+"|#|"+that.date2.format("yyyy-MM-dd"));
					var that = this;
					this.dinnerData = [
						{
							dateStr : "星期一",
							breakfast: "无",
							lunch: "无",
                            dinner: "无",
						},
						{
							dateStr : "星期二",
							breakfast: "无",
							lunch: "无",
                            dinner: "无",
						},
						{
							dateStr : "星期三",
							breakfast: "无",
							lunch: "无",
                            dinner: "无",
						},
						{
							dateStr : "星期四",
							breakfast: "无",
							lunch: "无",
                            dinner: "无",
						},
						{
							dateStr : "星期五",
							breakfast: "无",
							lunch: "无",
                            dinner: "无",
						}
					];
//                  var params = {
//                      token: window.localStorage.getItem("token"),
//                      url: '/sys/bookmealsetting/list',
//                      success: (res) => {
//                      	console.log("--------------",that.dinnerData)
//                          for(var j=0;j<that.dinnerData.length;j++){
////                          	that.showBtn = [];
////                          	that.showBtn2 = [];
////                          	that.showBtn.push(false);
////                          	that.showBtn2.push(false);
////                              that.dinnerData[j].breakfast = res.data.result.result[j].breakfast;
////                              that.dinnerData[j].breakfast = res.data.result.result[j].breakfast;
////                              that.dinnerData[j].lunch = res.data.result.result[j].lunch;
//                          }
//                      }
//                  }
                    var params = {};
	                params.url = '/sys/bookmealsetting/list';
	                params.token = window.localStorage.getItem("token");
	                params.data = {};
	                params.success = function (res) {
	                  	var data = res.data.result.result[0];
	                  	that.dinnerData[0].breakfast = data.Monday_breakfast;
	                  	that.dinnerData[0].lunch = data.Monday_lunch;
	                  	that.dinnerData[0].dinner= data.Monday_dinner;
	                  	that.dinnerData[1].breakfast = data.Tuesday_breakfast;
	                  	that.dinnerData[1].lunch = data.Tuesday_lunch;
	                  	that.dinnerData[1].dinner = data.Tuesday_dinner;
	                  	that.dinnerData[2].breakfast = data.Wednesday_breakfast;
	                  	that.dinnerData[2].lunch = data.Wednesday_lunch;
	                  	that.dinnerData[2].dinner = data.Wednesday_dinner;
	                  	that.dinnerData[3].breakfast = data.Thursday_breakfast;
	                  	that.dinnerData[3].lunch = data.Thursday_lunch;
	                  	that.dinnerData[3].dinner = data.Thursday_dinner;
	                  	that.dinnerData[4].breakfast = data.Friday_breakfast;
	                  	that.dinnerData[4].lunch = data.Friday_lunch;
	                  	that.dinnerData[4].dinner = data.Friday_dinner;
	                };
	                this.ajaxPost(params);
            },
        },
        mounted: function() {
			this.serchDate()
        }
    }
</script>
<style lang="scss">
	.isGray{
		background: #f9f9f9;
	}
	.buttonIt{
		div{
			display: block;
			width: 100%;
			height: 100%;
			background: url("../../assets/dinnerMana/bjIcon.png") no-repeat center;
		}
	}
    .top{
        padding: 30px 40px;
        text-align: right;
        h2{
            font-size: 36px;
            text-align: left;
        }
    }
    .haveK{
    	border: 1px solid #ccc !important;
    }
    .menu{
        height: 100%;
    }
    .tottom{
        max-height: 800px;
        padding: 0 40px;
        overflow-y: scroll;
    }
    .tableList{
        overflow-y: scroll;
        overflow-x: hidden;
        width: 100%;
        text-align: center;
        border-top: 0;
        border-color: #ededed;
        font-size: 14px;
        border: 0;
        td{
            width: 30%;
            word-break: break-all;
            height: 45px;
            input{
                width: 94%;
                border: 0;
                height: 70%;
                padding: 5px;
                display: inline-block;
            }
        }
        td:last-child{
        	width: 10%;
        }
    }
    .tableList:first-child{
        border-top: 1px solid #ededed;
    }
    .btton{
        height: 40px;
        width: 160px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        line-height: 8px;
        padding: 16px;
        margin-top: 36px;
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/menu.vue